import { IsPhoneNumber, IsNotEmpty } from 'class-validator';

export class VerifyPhoneNumberInput {
  @IsPhoneNumber('US', { message: 'Please enter a valid phone number' })
  @IsNotEmpty({ message: 'Please enter a mobile number' })
  phoneNumber: string;
}
